import {GetStaticPropsResult} from 'next';

export abstract class AbstractControllerException extends Error {
    public abstract makeNextControllerObject(): GetStaticPropsResult<unknown>;

    public static isIt(exception: unknown): exception is AbstractControllerException {
        return exception instanceof AbstractControllerException;
    }
}
